import { SButton } from '@setvi/shared/components';
import CloseIcon from '@material-ui/icons/Close';
import { styled } from '@material-ui/core';

const StyledButton = styled(SButton)(({ theme }) => ({
  minHeight: 'max-content',
  padding: theme.spacing(2, 3),
  fontSize: 12,
  position: 'absolute',
  fontWeight: 500,
  bottom: 12,
  right: 12
}));

interface ClearAllProps {
  onClear: () => void;
}

export const ClearButton = ({ onClear }: ClearAllProps) => (
  <StyledButton
    variant="text"
    startIcon={<CloseIcon />}
    onClick={() => onClear()}>
    Clear All
  </StyledButton>
);
